function isMobileDevice() {
  return window.innerWidth <= 1200;
}

function toggleSelectFilterProducts() {
  const wrappers = document.querySelectorAll(
    ".wrapper-filters-menu .custom-select-wrapper"
  );

  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const header = wrapper.querySelector(".custom-select-header");
    const options = wrapper.querySelectorAll(".custom-select-option");

    header.addEventListener("click", () => {
      wrappers.forEach((w) => {
        if (w !== wrapper) w.classList.remove("open");
      });
      wrapper.classList.toggle("open");
    });

    options.forEach((option) => {
      option.addEventListener("click", (e) => {
        e.stopPropagation();
        option.classList.toggle("selected");
      });
    });
  });

  document.addEventListener("click", function (e) {
    wrappers.forEach((wrapper) => {
      if (!wrapper.contains(e.target)) {
        wrapper.classList.remove("open");
      }
    });
  });
}

function functionsFiltersProducts() {
  const toggleFiltersMobile = document.querySelectorAll(
    ".wrapper-filters-menu .toggle-filters-mobile"
  );
  const containerFiltersMobile = document.querySelector(
    ".wrapper-filters-menu .wrapper-filters-mobile"
  );

  if (!toggleFiltersMobile.length || !containerFiltersMobile) return;

  toggleSelectFilterProducts();

  if (isMobileDevice()) {
    toggleFiltersMobile.forEach((button) => {
      button.addEventListener("click", () => {
        containerFiltersMobile.classList.toggle("active");
      });
    });
  }
}

export { functionsFiltersProducts };
